import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { Observable, catchError, from, switchMap } from "rxjs";
import { IdTokenResult } from "@angular/fire/auth";
import { EndpointsService } from "../services/endpoints.service";

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    // { url: '', method: 'GET' }
    private excludedUrls: any[] = [];

    constructor(
        private authService: AuthService,
        private endpointsService: EndpointsService
    ) {
        this.excludedUrls.push({ url: this.endpointsService.tag, method: 'POST' });
        this.excludedUrls.push({ url: this.endpointsService.parameters, method: 'GET' });
        this.excludedUrls.push({ url: '/cassandra/doclegal/documents/latest?type=', method: 'GET' });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //Si es un servicio que no necesita autenticación sin importar el tipo de usuario.
        if (this.verifyExcludedUrl(req.url, req.method)) {
            return next.handle(req);
        }

        return from(this.authService.getGuestFlag()).pipe(switchMap((isGuest: boolean) => {
            //Es invitado.
            if (isGuest) {
                let request = req.clone({
                    headers: req.headers.set('trial', 'trial')
                });
                return next.handle(request);
            }

            //Es un usuario.
            //Esto es para brincar pago
/*             if(req.url == 'https://back.baguu.mx/payments/praga' || req.url =='https://back.baguu.mx/payments/reference'){
                return from(this.authService.getCurrentToken()).pipe(switchMap((userToken: IdTokenResult) => {
                    let request = req.clone({
                        headers: req.headers.set('Authorization', 'Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6ImE4ZGY2MmQzYTBhNDRlM2RmY2RjYWZjNmRhMTM4Mzc3NDU5ZjliMDEiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vYmFndXUtcHJvZCIsImF1ZCI6ImJhZ3V1LXByb2QiLCJhdXRoX3RpbWUiOjE3NTI2MDQ2NTIsInVzZXJfaWQiOiJuSmEzS0xEdVRWYTVHc2dJczk3RE83REs5M2IyIiwic3ViIjoibkphM0tMRHVUVmE1R3NnSXM5N0RPN0RLOTNiMiIsImlhdCI6MTc1MjYwNDY1MiwiZXhwIjoxNzUyNjA4MjUyLCJlbWFpbCI6Im5ydWdhcmNpYUBhZHZpc29yeXNlcnZpY2VzZy50ZWNoIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsibnJ1Z2FyY2lhQGFkdmlzb3J5c2VydmljZXNnLnRlY2giXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.HEwaKbTIaCo0lf-1YbB4WxWEMzTWCIMtaEPGnooWv6l8khpk0FUGhYH-JxYyJgWDGxdOrOkh7bWzH4WvJK1jxVOSNZdjIXoxGUY1tcwiuHZiixO42qLoj5VDY9gnXKnrq9Q_EdSu9yC5kHEhOPa1jd52DgPHkvlmK89VjEvXTe9Qztz6sBvxmcKLVOhWHvxSKl53m9egSpuOAprY8MPNZbsLkuV_CDioD0sRklTOijN6_h7_5qYilIRcZuJIXaJEncR_oCqLSCcINXPTwAybbHmkgIkt160uXhjB9RkjxSH1J1LBDiwJGAPDPcrt3gzHUf48TYW5NknIh-WR5aYcjg')
                    });
                    return next.handle(request);
                }));

            }else{ */ 
                return from(this.authService.getCurrentToken()).pipe(switchMap((userToken: IdTokenResult) => {
                    let request = req.clone({
                        headers: req.headers.set('Authorization', `Bearer ${userToken.token}`)
                    });
                    return next.handle(request);
                }));
            //}
        }));
    }

    verifyExcludedUrl(url: string, method: string): boolean {
        let flag: boolean = false;
        for (let except of this.excludedUrls) {


            flag = (url.includes(except.url) && method == except.method);
            if (flag) {
                break;
            }
        }



        return flag;
    }

}